import React from "react";
import ReactStars from "react-stars";
import { FormFeedback } from "reactstrap";

import "./StarRating.css";

class StarRating extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(newRating) {
    this.setState({
      value: newRating
    });
    this.props.input.onChange(newRating);
  }

  render() {
    const { count } = this.props;
    return (
      <div>
        <div className="star-rating">
          <ReactStars
            count={count}
            onChange={this.onChange}
            half={false}
            size={32}
            value={this.props.input.value}
            color2={"#ffd700"}
          />
          {this.state.value && (
            <div className="rating-applied">{this.state.value} stars</div>
          )}
        </div>
        {this.props.meta.touched &&
          this.props.meta.error && (
            <FormFeedback style={{ display: "block" }}>
              {this.props.meta.error}
            </FormFeedback>
          )}
      </div>
    );
  }
}

export default StarRating;



// WEBPACK FOOTER //
// ./src/system/fields/StarRating/index.jsx